import { render, staticRenderFns } from "./videoCall.vue?vue&type=template&id=f306443a&scoped=true"
import script from "./videoCall.vue?vue&type=script&lang=js"
export * from "./videoCall.vue?vue&type=script&lang=js"
import style0 from "./videoCall.vue?vue&type=style&index=0&id=f306443a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f306443a",
  null
  
)

export default component.exports